/**
 * Roguelite Modifier Apply — compose modifiers onto a base WeaponDef.
 */

import type { WeaponDef } from '../weapons/types';
import { lookupModifier } from './modifier-registry';

/** Apply a list of modifier IDs to a base weapon, returning a modified copy. */
export function applyModifiers(baseWeapon: WeaponDef, modIds: string[]): WeaponDef {
  // Shallow copy — spread nested objects to prevent mutation of original
  const weapon: WeaponDef = { ...baseWeapon };
  weapon.craterShape = { ...baseWeapon.craterShape };

  for (const id of modIds) {
    const mod = lookupModifier(id);
    if (!mod) continue;

    // Field mutations
    if (mod.fieldMutations) {
      const mutations = mod.fieldMutations(weapon);
      Object.assign(weapon, mutations);
    }

    // Hook wrappers (Phase 2 — onImpact, onBounce chaining)
    if (mod.wrapOnImpact) {
      weapon.onImpact = mod.wrapOnImpact(weapon.onImpact);
    }
    if (mod.wrapOnBounce) {
      weapon.onBounce = mod.wrapOnBounce(weapon.onBounce);
    }
  }

  return weapon;
}
